module.exports = __webpack_public_path__ + "img/icons-nav.73664163.png";